export const COURSE_MAP = {
  work: 'Для работы',
  interview: 'Для собеседований',
  beginner: 'С нуля за 3 месяца',
  pro: 'Для профи',
  common: 'Общий английский'
};